export enum ProcedureStates {
  // Initiated = 1,
  // PendingResponse,
  // Accepted,
  // Rejected,
  // Incidence,
  // PendingActivation,
  // Active,
  // Closed,
  // RequestAdditionalInformation,
  // AdditionalInformationSubmitted,
  // PendingShipment,
  // CancellationRequested,
  // Canceled,
  // CancellationRejected

  Iniciado = 1,
  Pendiente_Respuesta = 2,
  Aceptado = 3,
  Rechazado = 4,
  Incidencia = 5,
  Pendiente_Activacion = 6,
  Activo = 7,
  Cerrado = 8,
  PendienteInformacion = 9,
  Informacion_Adicional_Enviada = 10,
  Pendiente_Envio = 11,
  Anulacion_solicitada = 12,
  Anulado = 13,
  Anulacion_Rechazada = 14,
  AnalisisRechazo = 15,
  Descartado = 16,
  Bloqueado = 17
}
